import { Spin, Typography } from "antd";
import PropTypes from "prop-types";

import { FIELD_PREVIEW_DEFAULT_VALUE } from "@/components/Elements/FieldPreview/FieldPreview.constant";
import TextEllipsis from "@/components/Elements/TextEllipsis";

const { Text } = Typography;

const TextFieldPreview = ({ value, ellipsis, loading }) => {
  if (loading)
    return (
      <span role="status">
        <Spin size="small" />
      </span>
    );

  if (!value) return FIELD_PREVIEW_DEFAULT_VALUE;

  if (ellipsis) return <TextEllipsis>{value}</TextEllipsis>;

  return <Text>{value}</Text>;
};

TextFieldPreview.propTypes = {
  value: PropTypes.string,
  ellipsis: PropTypes.bool,
  loading: PropTypes.bool,
};

export default TextFieldPreview;
